import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Tachograph = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M21.262 10.738C16.924 6.38798 11.149 4.00098 5 4.00098C4.45 4.00098 4 4.45098 4 5.00098V9.00098C4 9.55098 4.45 10.001 5 10.001C5.55 10.001 6 9.55098 6 9.00098V6.02598C10.9 6.25098 15.5 8.15098 19.125 11.464L16.288 14.302C16.113 14.477 16 14.727 16 15.015C16 15.565 16.45 16.015 17 16.015C17.275 16.015 17.525 15.902 17.712 15.728L20.549 12.89C23.849 16.515 25.749 21.115 25.987 26.015H22.999C22.449 26.015 21.999 26.465 21.999 27.015C21.999 27.565 22.449 28.015 22.999 28.015H26.999C27.549 28.015 27.999 27.565 27.999 27.015C27.999 20.852 25.612 15.077 21.261 10.74L21.262 10.738Z" />
		<path d="M13.713 19.712C13.888 19.537 14 19.287 14 19C14 18.45 13.55 18 13 18C12.725 18 12.475 18.113 12.287 18.288L10.024 20.55C9.42402 20.2 8.73702 20 7.99902 20C5.79902 20 3.99902 21.8 3.99902 24C3.99902 26.2 5.79902 28 7.99902 28C10.199 28 11.999 26.2 11.999 24C11.999 23.262 11.799 22.562 11.449 21.975L13.712 19.713L13.713 19.712ZM8.00002 26C6.90002 26 6.00002 25.1 6.00002 24C6.00002 22.9 6.90002 22 8.00002 22C9.10002 22 10 22.9 10 24C10 25.1 9.10002 26 8.00002 26Z" />
	</svg>
);

export default Tachograph;
